/* LUVEA — LA BONNE VARIANTE PART AU PANIER (07/08).

   LE BUG
   Le formulaire d'ajout au panier contient DEUX champs nommes "id" :

     1. <select id="productSelect" name="id">  <- le selecteur du theme, tenu a
        jour a chaque changement d'option (et par ?variant= a l'ouverture) ;
     2. <input type="hidden" name="id">        <- pose en dur par
        product-details.liquid avec product.variants.first.id, et JAMAIS remis
        a jour ensuite.

   Un formulaire envoie TOUS ses champs de meme nom, dans l'ordre du DOM, et
   Shopify ne retient que le DERNIER. Le dernier, ici, c'est le champ fige sur
   la premiere variante. Resultat : la cliente choisit la lettre M, la page
   affiche M, l'URL affiche M... et la commande part en A.

   Sur le collier Amora, dont la LETTRE est une vraie option de variante, ca se
   voit tout de suite. Sur un bijou ou seule la finition change, ca ne se voit
   pas a l'ecran : on livre simplement du plaque or a qui a commande de
   l'argent.

   POURQUOI CE CORRECTIF EST EN JAVASCRIPT
   La cause est une ligne de product-details.liquid, un fichier de 141 Ko qu'on
   ne peut pas re-televerser sans risque de troncature. Et de toute facon
   corriger la valeur initiale ne suffirait pas : il faut suivre les
   changements de la cliente. On synchronise donc, en continu.

   QUI FAIT AUTORITE
   Le <select name="id"> du theme. C'est lui que le theme met a jour, et c'est
   aussi lui que les configurateurs Luvea (Aria, Laura, Angela...) ecrivent
   quand ils imposent une variante. Aucun conflit : ils visent la meme valeur.

   S'IL N'Y A PAS DE SELECT (produit a variante unique), il n'y a rien a
   corriger : le champ cache est alors la seule source, et il est juste.
*/
(function () {
  var form = document.querySelector('form[action*="/cart/add"]');
  if (!form || form.dataset.lvVarBound) { return; }

  var maitre = form.querySelector('select[name="id"]');
  if (!maitre) { return; }
  form.dataset.lvVarBound = '1';

  function aligner() {
    var v = maitre.value;
    if (!v) { return; }
    var champs = form.querySelectorAll('[name="id"]');
    for (var i = 0; i < champs.length; i++) {
      if (champs[i] !== maitre && champs[i].value !== v) { champs[i].value = v; }
    }
  }

  /* Au moment ou ca compte vraiment : en capture, donc AVANT le gestionnaire
     d'ajout au panier du theme et avant celui du tiroir. */
  form.addEventListener('submit', aligner, true);
  form.addEventListener('click', function (e) {
    if (e.target.closest('[type="submit"], .add-to-cart, .single-add-to-cart-button')) { aligner(); }
  }, true);

  /* Pendant la navigation : chaque changement d'option passe par un 'change'
     qui remonte jusqu'au formulaire. Le theme reagit lui aussi a cet
     evenement, et parfois apres nous -- d'ou les rappels differes. */
  form.addEventListener('change', function () {
    aligner();
    setTimeout(aligner, 60);
    setTimeout(aligner, 300);
  }, true);

  /* Filet. Certaines mises a jour de variante ne passent par aucun evenement
     observable (ecriture directe de .value par une application, retour arriere
     du navigateur). Un alignement leger suffit a les rattraper. */
  setInterval(aligner, 500);

  aligner();
})();
